import { render } from "./UETreatmentBenefitView.vue?vue&type=template&id=4e5ed033&scoped=true"
import script from "./UETreatmentBenefitView.vue?vue&type=script&lang=js"
export * from "./UETreatmentBenefitView.vue?vue&type=script&lang=js"

import "./UETreatmentBenefitView.vue?vue&type=style&index=0&id=4e5ed033&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5ed033"]])

export default __exports__